import { useView, autoinject, Container, transient, inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';

@transient()
@autoinject()
export default class TabViewModel {
    
    Header: string;
    ChildNodeGroups: any[] = [];
    protected container: Container;
    protected router: Router;
    constructor() {
        this.container = Container.instance;
    }

    GetChildNode(groupName = null) {
        if (groupName == null)
            groupName = "default";
        
        if (!this.ChildNodeGroups.hasOwnProperty(groupName)) {
            this.ChildNodeGroups[groupName] = [];
        }

        return this.ChildNodeGroups[groupName];
    }

    OnCurrentChanged(sender, e) {

    }

    ClearChildNode(groupName = null) {
        if (groupName == null)
            groupName = "default";

        if (this.ChildNodeGroups.hasOwnProperty(groupName)) {
            this.ChildNodeGroups[groupName] = [];
        }
    }

    AddChildNode(node, groupName = null) {
        if (groupName == null)
            groupName = "default";
        if (!this.ChildNodeGroups.hasOwnProperty(groupName)) {
            this.ChildNodeGroups[groupName] = [];
        }
        this.ChildNodeGroups[groupName].push(node);
    };

    RemoveChildNode(node, groupName = null) {
        if (groupName == null)
            groupName = "default";

        for (var i = 0; i < this.ChildNodeGroups.length; i++) {
            if (this.ChildNodeGroups[i] === node) {
                this.ChildNodeGroups.splice(i, 1);
            }
        }
    };
}